import React, { Component } from "react";
import PropTypes from "prop-types";
import { feedRequest, resetFeed } from "../actions/feed.actions";
import { wrapComponent } from "../utils/container";
import CorrectionPostDialogs from "./CorrectionPostDialogs";
import {
    newCorrection,
    submitComment,
    toggleCorrectionReaction,
    determineCorrectionAction
} from "../actions/correction.actions";
import PostScroll from "../components/PostScroll";
import LoadingError from "../components/LoadingError";
import {
    determinePostAction,
    newPost,
    togglePostReaction
} from "../actions/post.actions";
import { Typography, IconButton, Tooltip } from "material-ui";
import RefreshIcon from "material-ui-icons/Refresh";
import NewPostCard from "../components/NewPostCard";
import { grey } from "material-ui/colors";
import EmptyState from "../components/EmptyState";

const styleSheet = theme => ({
    "@media (min-width: 500px)": {
        mainContainer: {
            margin: "0 auto"
        }
    },
    flexTitle: {
        display: "flex",
        alignItems: "center"
    },
    mainContainer: {
        maxWidth: 600,
        padding: 0,
        width: "100%"
    },
    button: {
        margin: theme.spacing.unit
    },
    fabButton: {
        margin: theme.spacing.unit,
        position: "fixed",
        bottom: 2 * theme.spacing.unit,
        right: 2 * theme.spacing.unit
    },
    newPostCardContainer: {
        margin: `${2 * theme.spacing.unit}px 0`
    },
    feedTitle: {
        margin: `0 0 0 ${3 * theme.spacing.unit}px`,
        fontWeight: 300,
        color: grey[700],
        flex: 1
    },
    refreshIcon: {
        width: 24,
        height: 24,
        margin: `0 ${3 * theme.spacing.unit}px 0 0`,
        padding: 0
    },
    "@media (min-width: 600px)": {
        newPostCardContainer: {
            margin: 2 * theme.spacing.unit
        },
        feedTitle: {
            margin: `0 0 0 ${5 * theme.spacing.unit}px`
        },
        refreshIcon: {
            margin: `0 ${5 * theme.spacing.unit}px 0 0`
        }
    }
});

class FeedPage extends Component {
    handleCorrectionButtonClick = post => {
        return () => {
            this.props.dispatch(newCorrection({ post }));
        };
    };

    loadMore = () => {
        const { feed: { pageInfo: { endCursor } } } = this.props;
        this.props.dispatch(feedRequest({ after: endCursor }));
    };

    onReactionButtonClick = payload => {
        this.props.dispatch(togglePostReaction(payload));
    };

    onCorrectionReactionButtonClick = payload => {
        this.props.dispatch(toggleCorrectionReaction(payload));
    };

    onSubmitComment = payload => {
        this.props.dispatch(submitComment(payload));
    };

    onPostMenuClick = ({ post, action }) => {
        this.props.dispatch(determinePostAction(action)({ post }));
    };

    onCorrectionMenuItemClick = ({ correction, action }) => {
        this.props.dispatch(determineCorrectionAction(action)({ correction }));
    };

    onNewPostClick = () => {
        this.props.dispatch(newPost());
    };

    resetFeed = () => {
        this.props.dispatch(resetFeed());
    };

    renderContents() {
        const {
            feed: {
                request: { requesting, errors },
                edges,
                pageInfo: { hasNextPage }
            },
            userSettings,
            classes,
            t
        } = this.props;

        let content;
        if (!hasNextPage && edges.count() === 0) {
            content = (
                <EmptyState
                    message={t(
                        "feedPage.We can't seem to find any posts for you"
                    )}
                />
            );
        } else if (errors && errors.count() > 0) {
            content = (
                <LoadingError
                    message={t(
                        "feedPage.Something went wrong loading the feed"
                    )}
                    onRetry={this.loadMore}
                />
            );
        } else {
            content = (
                <PostScroll
                    onCorrectionMenuItemClick={this.onCorrectionMenuItemClick}
                    onSubmitComment={this.onSubmitComment}
                    onReactionButtonClick={this.onReactionButtonClick}
                    onCorrectionReactionButtonClick={
                        this.onCorrectionReactionButtonClick
                    }
                    onCorrectionButtonClick={this.handleCorrectionButtonClick}
                    edges={edges}
                    currentUser={userSettings}
                    hasMore={hasNextPage}
                    loadMore={this.loadMore}
                    onMenuClick={this.onPostMenuClick}
                />
            );
        }
        return (
            <React.Fragment>
                <div className={classes.newPostCardContainer}>
                    <NewPostCard
                        currentUser={userSettings}
                        onClick={this.onNewPostClick}
                    />
                </div>
                <div className={classes.flexTitle}>
                    <Typography
                        className={classes.feedTitle}
                        component="h3"
                        type="body1">
                        {t("feedPage.Posts suggested for you")}
                    </Typography>
                    <Tooltip
                        title={t("feedPage.Refresh")}
                        className={classes.refreshIcon}>
                        <IconButton
                            onClick={this.resetFeed}
                            disabled={requesting}
                            className={classes.refreshIcon}>
                            <RefreshIcon />
                        </IconButton>
                    </Tooltip>
                </div>
                {content}
            </React.Fragment>
        );
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.mainContainer}>
                {this.renderContents()}
                <CorrectionPostDialogs />
            </div>
        );
    }
}

FeedPage.propTypes = {
    userSettings: PropTypes.object,
    classes: PropTypes.object,
    dispatch: PropTypes.func,
    feed: PropTypes.object,
    t: PropTypes.func.isRequired
};

function mapStateToProps({ userSettings, feed: { feedPagedRequest } }) {
    return {
        userSettings,
        feed: feedPagedRequest
    };
}

export default wrapComponent(FeedPage, styleSheet, mapStateToProps);



// WEBPACK FOOTER //
// ./src/containers/FeedPage.jsx